module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/Interface/24x24/ico_plus-7c9a7aaaf22abd0afdc904a54b3ed01d.svg";